/**
 * EditPortionModal - Extracted from App.js Phase 4
 * Adjust meal portion sizes with percentage slider
 */
import React from 'react';

const EditPortionModal = ({
  isOpen,
  onClose,
  editingMeal,
  portionPercent,
  setPortionPercent,
  portionLoading,
  savePortionEdit
}) => {
  if (!isOpen || !editingMeal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 className="heading-3" style={{ margin: 0 }}>Adjust Portion</h2>
          <button onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: 'var(--text-secondary)' }}>x</button>
        </div>
        
        <div style={{ padding: '12px', background: 'rgba(255,255,255,0.03)', borderRadius: '8px', marginBottom: '20px' }}>
          <p style={{ margin: 0, fontWeight: '500', marginBottom: '4px' }}>
            {editingMeal.food_items?.substring(0, 50) || 'Meal'}
          </p>
          <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-secondary)' }}>
            Original: {editingMeal.original_calories || editingMeal.calories} kcal
          </p>
        </div>
        
        <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '12px' }}>How much did you eat?</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px', marginBottom: '20px' }}>
          {[25, 50, 75, 100].map(pct => (
            <button key={pct} onClick={() => setPortionPercent(pct)}
              style={{
                padding: '12px 8px',
                background: portionPercent === pct ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'rgba(255,255,255,0.05)',
                border: portionPercent === pct ? 'none' : '1px solid rgba(255,255,255,0.1)',
                borderRadius: '8px',
                color: portionPercent === pct ? 'white' : 'var(--text-secondary)',
                fontWeight: portionPercent === pct ? '600' : '400',
                cursor: 'pointer', fontSize: '14px'
              }}>
              {pct}%
            </button>
          ))}
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Custom amount</span>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#667eea' }}>{portionPercent}%</span>
          </div>
          <input type="range" min="0" max="100" step="5" value={portionPercent}
            onChange={(e) => setPortionPercent(parseInt(e.target.value))}
            style={{ width: '100%', accentColor: '#667eea' }} />
        </div>
        
        <div style={{ padding: '12px', background: 'rgba(102, 126, 234, 0.1)', borderRadius: '8px', marginBottom: '20px', border: '1px solid rgba(102, 126, 234, 0.2)' }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: 'var(--text-secondary)' }}>Updated values:</p>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '20px', fontWeight: '700', color: '#667eea' }}>
              {Math.round((editingMeal.original_calories || editingMeal.calories) * portionPercent / 100)} kcal
            </span>
            <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
              P: {Math.round((editingMeal.original_protein || editingMeal.protein || 0) * portionPercent / 100)}g | 
              C: {Math.round((editingMeal.original_carbs || editingMeal.carbs || 0) * portionPercent / 100)}g | 
              F: {Math.round((editingMeal.original_fat || editingMeal.fat || 0) * portionPercent / 100)}g
            </span>
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '12px' }}>
          <button onClick={onClose}
            style={{ flex: 1, padding: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px', color: 'var(--text-secondary)', fontSize: '14px', cursor: 'pointer' }}>
            Cancel
          </button>
          <button onClick={savePortionEdit} disabled={portionLoading}
            style={{ flex: 1, padding: '14px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none', borderRadius: '8px', color: 'white', fontWeight: '600', fontSize: '14px',
              cursor: portionLoading ? 'not-allowed' : 'pointer', opacity: portionLoading ? 0.7 : 1 }}>
            {portionLoading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPortionModal;
